import { IkasBaseModel } from "../../base";
import { IkasImage } from "../../image";

export type IkasCustomerReview = {
  comment: string | null;
  customerId: string | null;
  email: string | null;
  firstName: string | null;
  imageIds: string[] | null;
  lastName: string | null;
  orderId: string | null;
  orderNumber: string | null;
  productId: string;
  salesChannelId: string | null;
  star: number;
  status: IkasCustomerReviewStatus | null;
  storefrontId: string | null;
  title: string | null;

  // Extra
  images?: IkasImage[] | null;
} & IkasBaseModel;

export enum IkasCustomerReviewStatus {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  WAITING = "WAITING",
}
